import React, {
  useMemo,
} from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareText } from '../comparators/compareText';
import { TextFilter } from '../filters/TextFilter';
import 'draft-js/dist/Draft.css';
import { Stack } from '@mui/material';
import TextEditor from './TextEditor';
import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';

const parseJsonToEditorState = (jsonData: any) => {
  const contentState = convertFromRaw(JSON.parse(jsonData)); // Visszaalakítjuk a JSON-t ContentState-re
  const html = stateToHTML(contentState); // A ContentState HTML-re alakítása
  return html;
};

const isJsonString = (str: string): boolean => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const SPRichTextField: FieldComponent<string, string[]> = ({
  onChange,
  defaultValue,
  column,
}) => {
  const handleEditorChange = (updatedHtml: any) => {
    if (defaultValue === updatedHtml) {
      return;
    }

    onChange(updatedHtml);
    return;
  };

  const initialHtml = useMemo(() => {
    if (isJsonString(defaultValue) && defaultValue) {
      return parseJsonToEditorState(defaultValue);
    } else {
      return defaultValue ? defaultValue : '';
    }
  }, []);

  return (
    <Stack
      className="w-full"
      sx={{
        position: 'relative',
      }}
    >
      <TextEditor
        initialHtml={initialHtml}
        column={column}
        onChange={handleEditorChange}
      />
    </Stack>
  );
};

SPRichTextField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

SPRichTextField.comparator = compareText;

SPRichTextField.FilterRenderer = TextFilter;
